import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: "#F5F5F5",
      }}
    >
      <Box
        sx={{
          maxWidth: "1440px",
          px: "100px",
          py: "56px",
          "@media (max-width: 1360px)": {
            px: "16px",
            py: "32px",
          },
        }}
      >
        <Box
          sx={{
            backgroundColor: "white",
            boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
            p: "48px",
            "@media (max-width: 1024px)": {
              p: "36px",
            },
            "@media (max-width: 856px)": {
              p: "16px",
            },
          }}
        >
          {/* Main Title */}
          <Typography
            sx={{
              fontSize: "36px",
              fontWeight: "700",
              color: "#333",
              mb: 4,
              lineHeight: 1.2,
            }}
          >
            Privacy Policy
          </Typography>

          {/* Introduction */}
          <Typography
            sx={{
              fontSize: "16px",
              color: "#666",
              mb: 4,
              lineHeight: 1.6,
            }}
          >
            R3PLAY LLC is committed to protecting your privacy. Our Privacy
            Policy is designed to protect the information that we collect from
            you over the web site while providing you with our products and
            services. We want to inform you of our Privacy Policy and to ensure
            that we are taking steps to make sure that the information you give
            us is secure.
          </Typography>

          {/* Collection of Information Section */}
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "600",
              color: "#333",
              mb: 2,
              lineHeight: 1.3,
            }}
          >
            Collection of Information
          </Typography>

          <Typography
            sx={{
              fontSize: "16px",
              color: "#666",
              mb: 4,
              lineHeight: 1.6,
            }}
          >
            We require information about our visitors, primarily clients and
            collaborators, in the course of obtaining R3PLAY LLC products and
            services through our web site (https://r3play.com). This information
            may include your name, e-mail address, and similar data.
          </Typography>

          {/* Usage of Collected Information Section */}
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "600",
              color: "#333",
              mb: 2,
              lineHeight: 1.3,
            }}
          >
            Usage of Collected Information
          </Typography>

          <Typography
            sx={{
              fontSize: "16px",
              color: "#666",
              mb: 4,
              lineHeight: 1.6,
            }}
          >
            If you contact our customer success department regarding a support
            question you have inquired, we will have information about you in
            order to serve you. We use your personal information to provide you
            access to specific areas on our web site for you to create data
            required to have the best user experience. We do not collect
            information about our clients or visitors from other sources, such
            as public records or bodies or private organizations. Also, we do
            not automatically record personal data, or link information logged
            by other means with personal data about specific individuals.
          </Typography>

          {/* Restricted Access Section */}
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "600",
              color: "#333",
              mb: 2,
              lineHeight: 1.3,
            }}
          >
            Restricted Access to Collected Information
          </Typography>

          <Typography
            sx={{
              fontSize: "16px",
              color: "#666",
              mb: 2,
              lineHeight: 1.6,
            }}
          >
            We keep your information private and do not share it with any entity
            outside R3PLAY LLC, except as stated below. We do not sell or give
            your information to marketing companies. We might use the
            information to contact you when we introduce new products or
            services, and we might share your contact information with the
            providers of third-party software codes that we incorporate into our
            end-user products. You can ask us if we are keeping personal data
            about you and/or list of third-party provider companies by sending
            an e-mail to{" "}
            <Typography
              component="span"
              sx={{
                color: "#EF5658",
                fontWeight: "500",
              }}
            >
              letsplay@r3play.com
            </Typography>
            . We will then provide you with a readable copy of the requested
            material. We will require proof of your identity before providing
            such data.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default PrivacyPolicy;
